module.exports = __webpack_public_path__ + "static/media/nft.601e50b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nft.mp4
// module id = kT0Y
// module chunks = 1